var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecentGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2507 5C11.4808 5 11.6673 5.18655 11.6673 5.41667V9.58333H15.4173C15.6474 9.58333 15.834 9.76988 15.834 10C15.834 10.2301 15.6474 10.4167 15.4173 10.4167H11.2507C11.0205 10.4167 10.834 10.2301 10.834 10V5.41667C10.834 5.18655 11.0205 5 11.2507 5Z",
    fill: "#A6A6A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.602578 6.72871C0.794048 6.60107 1.05274 6.65281 1.18039 6.84428L3.37851 10.1415L5.9368 7.21769C6.08833 7.04451 6.35157 7.02696 6.52475 7.1785C6.69793 7.33003 6.71548 7.59326 6.56394 7.76645L3.64728 11.0998C3.56187 11.1974 3.43589 11.2497 3.30647 11.2412C3.17705 11.2327 3.05896 11.1644 2.98702 11.0565L0.487016 7.30653C0.359369 7.11506 0.411108 6.85636 0.602578 6.72871Z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.91699 9.58333C2.91699 4.97821 6.64521 1.25 11.2503 1.25C15.8554 1.25 19.5837 4.97821 19.5837 9.58333C19.5837 14.1885 15.8554 17.9167 11.2503 17.9167C11.0202 17.9167 10.8337 17.7301 10.8337 17.5C10.8337 17.2699 11.0202 17.0833 11.2503 17.0833C15.3952 17.0833 18.7503 13.7282 18.7503 9.58333C18.7503 5.43845 15.3952 2.08333 11.2503 2.08333C7.10544 2.08333 3.75033 5.43845 3.75033 9.58333V10.8252C3.75033 11.0553 3.56378 11.2419 3.33366 11.2419C3.10354 11.2419 2.91699 11.0553 2.91699 10.8252V9.58333Z",
    fill: "#A6A6A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecentGray);
export default __webpack_public_path__ + "static/media/recent_gray.2895ce181f561294b865d74defd2353c.svg";
export { ForwardRef as ReactComponent };